
import React, { PureComponent, Fragment } from "react";
import styles from "./ClanWarsWelcome.scss";
import { t } from "../../helpers/localization";

import { ButtonPromo, CheckboxWithLabel, Divider, StepCSSTransitionGroup, DivTooltip, TooltipBody } from "@wg/wows-react-uikit";

import { permissions, iHavePermission } from "../../roles";

type Props = {
  clanId: number | null;
  currentAccount: any;
  autoParticipation: boolean;
  toggleAutoParticipation: () => void;
  setIsParticipant: (value: boolean) => void;
  navigateToRecommendations: () => void,
};

class ClanWarsWelcome extends PureComponent<Props> {


  setIsParticipant = () => {
    this.props.setIsParticipant(true);
  };

  render() {
    return <div className={styles.container}>
                <div className={styles.headImage} />
                <div className={styles.content}>
                    <StepCSSTransitionGroup level={1}>
                        <h2 className={styles.title}>{t('Морское сражение начинается')}</h2>
                    </StepCSSTransitionGroup>
                    <StepCSSTransitionGroup level={2}>
                        <div className={styles.textBlock}>
                            <p>- {t('Нет фиксированного прайм-тайма, играйте когда вам удобно')}</p>
                            <p>- {t('Участвуют и получают награды кланы с любой активностью')}</p>
                        </div>

                        <div className={styles.textBlock}>
                            <p>{t('Участвуйте в боях и зарабатывайте награды для себя и вашего клана')}</p>
                        </div>
                    </StepCSSTransitionGroup>
                    {this.props.clanId ? <StepCSSTransitionGroup level={3}>
                            <div className={styles.center}>
                                <DivTooltip tooltipBody={iHavePermission(permissions.CWARS_TOGGLE_PARTICIPATION, this.props.currentAccount) ? null : <TooltipBody>
                                            {t('Только Командующий вашего клана или Заместитель командующего могут зарегистрировать клан для участия в Морском сражении')}
                                        </TooltipBody>}>
                                    <ButtonPromo isCenter onClick={this.setIsParticipant} isDisabled={!iHavePermission(permissions.CWARS_TOGGLE_PARTICIPATION, this.props.currentAccount)}>
                                        {t('Участвовать')}
                                    </ButtonPromo>
                                </DivTooltip>
                            </div>
                        </StepCSSTransitionGroup> : <Fragment>
                            <StepCSSTransitionGroup level={3}>
                                <h2 className={styles.title}>{t('Для участия в морском сражении необходимо состоять в клане')}</h2>
                            </StepCSSTransitionGroup>
                            <StepCSSTransitionGroup level={3}>
                                <div className={styles.center}>
                                    <ButtonPromo isCenter onClick={this.props.navigateToRecommendations}>
                                        {t('Хочу в клан')}
                                    </ButtonPromo>
                                </div>
                            </StepCSSTransitionGroup>
                        </Fragment>}

                    {this.props.clanId ? <StepCSSTransitionGroup level={4}>
                            <div className={styles.center}>
                                <DivTooltip tooltipBody={iHavePermission(permissions.CWARS_TOGGLE_PARTICIPATION, this.props.currentAccount) ? null : <TooltipBody>
                                            {t('Только Командующий вашего клана или Заместитель командующего могут зарегистрировать клан для участия в Морском сражении')}
                                        </TooltipBody>}>
                                    <div className={styles.checkboxParticipate}>
                                        <CheckboxWithLabel labelText={t('Участвовать каждую неделю')} isCenter isChecked={this.props.autoParticipation} isDisabled={!iHavePermission(permissions.CWARS_TOGGLE_PARTICIPATION, this.props.currentAccount)} onChange={this.props.toggleAutoParticipation} />
                                    </div>
                                </DivTooltip>
                            </div>
                        </StepCSSTransitionGroup> : null}

                    <StepCSSTransitionGroup level={5}>
                        <div className={styles.divider}>
                            {/* @ts-ignore */}
                            <Divider className={styles.divider} type={'major'} />
                        </div>
                        <h2 className={styles.title}>{t('Этапы соревнования')}</h2>
                        <div className={styles.stages}>
                            <div>
                                <h3 className={styles.subTitle}>{t('Подготовка')}</h3>
                                <p>
                                    {t('Во время подготовительного этапа клан должен выполнить задачу для участия в битве. За выполнение задачи клан так же получает награду.')}
                                </p>
                                <p>
                                    {t('Начать подготовку можно в любой день до начала битвы.')}
                                </p>
                            </div>
                            <div>
                                <h3 className={styles.subTitle}>{t('Противостояние кланов')}</h3>
                                <p>
                                    {t('В битве участвуют кланы со всего мира. Битва занимает 2 дня после этапа подготовки.')}
                                </p>
                                <p>
                                    {t('В начале этого этапа мы вам подберем в противники схожий по активности клан. ')}
                                </p>
                            </div>
                        </div>
                    </StepCSSTransitionGroup>
                </div>
            </div>;
  }
}

export default ClanWarsWelcome;